<template class="mt-5">
  <quill-editor v-model="model" :options="editorOption" disabled> </quill-editor>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  components: { quillEditor },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    editor() {
      return this.$refs.quillEditor.quill;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
  data() {
    return {
      editorOption: {
        theme: 'bubble'   // Specify theme in configuration,
      },
    };
  },
};
</script>
